import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=78200a68&scoped=true&"
import script from "./Vote.vue?vue&type=script&lang=js&"
export * from "./Vote.vue?vue&type=script&lang=js&"
import style0 from "./Vote.vue?vue&type=style&index=0&id=78200a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78200a68",
  null
  
)

export default component.exports